export default __webpack_public_path__ + "static/media/ucp-btn.5ecdf2e3.svg";